import styled from "styled-components";
import { Heading5, WrapperContainer } from "../../components";
import { colors } from "../../consts";

export const AppNameTitle = styled(Heading5)`
  margin-bottom: 24px;
`;

export const AppManagementMenuContainer = styled.div`
  width: calc(100% - 4px);
  max-height: calc(100vh - 315px);

  overflow: ${(props) => (props.disableScroll ? "visible" : "scroll")};
`;

export const AppManagementContainer = styled(WrapperContainer)`
  min-height: 254px;
  border-left: 1px solid;
  border-color: ${colors.RAISIN_10};
`;

export const DashboardsSettingsWrapper = styled.div`
  cursor: pointer;

  svg {
    path {
      fill: ${colors.RAISIN_100};
    }
  }
`;
